import { showSuccess } from '@calendly/alert';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { Modal } from '@calendly/ui/components/modal';
import { Sheet } from '@calendly/ui/components/sheet';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { useFetchJoinableOrganizationsQuery } from 'features/organization/api';
import { RequestToJoinConfirm } from './request-to-join-confirm';
import { RequestToJoinOrgs } from './request-to-join-orgs';
import { RequestToJoinPending } from './request-to-join-pending';
const styledBodyCss = "s49gfw7";
const StyledBody = forwardRef((props, ref) => <Sheet ref={ref} {...props} className={classNames(styledBodyCss, props.className)} />);
const closeIconButtonCss = "cog3qva";
const CloseIconButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} aria-label={I18n.t('publisher.action.close_join_org_modal')} className={classNames(closeIconButtonCss, props.className)}>
    <CloseIcon />
  </BareButton>);
const JoinOrgStep = ({
  onClose,
  data,
  refetch
}) => {
  const [organization, setOrganization] = useState(null);
  const dispatch = useDispatch();
  const joinableOrganizations = data?.collection ?? [];
  const pendingOrganization = joinableOrganizations.find(({
    organizationInvitation
  }) => organizationInvitation?.status === 'user_pending');
  const onRequestCancelled = ({
    name
  }) => {
    refetch();
    dispatch(showSuccess(I18n.t('publisher.organization.join.modal.invitation_cancel.success', {
      owner_name: name
    })));
    onClose();
  };
  if (pendingOrganization) {
    return <RequestToJoinPending pendingOrganization={pendingOrganization} onRequestCancelled={onRequestCancelled} />;
  }
  const onCancel = () => {
    setOrganization(null);
  };
  const onRequestConfirmed = ({
    name
  }) => {
    refetch();
    dispatch(showSuccess(I18n.t('publisher.organization.join.modal.confirmation.success', {
      name
    })));
    onClose();
  };
  if (!organization) {
    return <RequestToJoinOrgs onConfirm={org => setOrganization(org)} joinableOrganizations={joinableOrganizations} />;
  }
  return <RequestToJoinConfirm onCancel={onCancel} onRequestConfirmed={onRequestConfirmed} organization={organization} />;
};
export const RequestToJoinModal = ({
  isOpen,
  onClose
}) => {
  const {
    data,
    refetch
  } = useFetchJoinableOrganizationsQuery();
  return <Modal isOpen={isOpen} onClose={onClose}>
      <StyledBody>
        <CloseIconButton onClick={onClose} />
        <JoinOrgStep onClose={onClose} data={data} refetch={refetch} />
      </StyledBody>
    </Modal>;
};

require("./request-to-join-modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./request-to-join-modal.js");